export default "__VITE_ASSET__Cr7u3kx9__"